import { useLayoutStore } from "../stores/layoutStore";
import { useUIStore } from "../stores/uiStore";

export function EditModeHud() {
  const editMode = useUIStore((s) => s.editMode);
  const pending  = useLayoutStore((s) => s.pendingTransform);

  if (!editMode || !pending) return null;

  return (
    <div style={{
      position: "absolute",
      bottom: 80,
      left: "50%",
      transform: "translateX(-50%)",
      background: "rgba(5,18,46,0.88)",
      border: "1px solid var(--op-blue-500)",
      borderRadius: "var(--radius-lg)",
      padding: "10px 18px",
      fontFamily: "var(--font-mono)",
      fontSize: 12,
      color: "var(--op-blue-300)",
      pointerEvents: "none",
      display: "flex",
      gap: 20,
      zIndex: 40,
    }}>
      <span>X <strong>{pending.originOffsetX.toFixed(2)}</strong> m</span>
      <span>Z <strong>{pending.originOffsetZ.toFixed(2)}</strong> m</span>
      <span>θ <strong>{(pending.rotationYRad * (180 / Math.PI)).toFixed(1)}</strong>°</span>
      <span>⊕ <strong>{pending.scale.toFixed(3)}</strong></span>
    </div>
  );
}
